import React from "react";

import styles from "./DataGroup.module.css";

const DataGroup = (props) => {
    return (
        <div className={styles.dataGroup}>
            <h3>{props.title}</h3>
            {props.children}
        </div>
    );
}

export default DataGroup;